export default {
  cancellation: {
    DESC_UNKNOWN: '유효하지 않은 취소 정책입니다',
    DESC_NO_CANCELLATION_AFTER_ISSUED:
      '티켓 등을 교환한 후 또는 액티비티 시작 이후에는 취소가 불가합니다',
    DESC_UPTO_X_DAYS_BEFORE_WITH_CHARGE:
      '예약 확정일로부터 참가일 {{if(P1>0)의 {{P1}}일 전 else 당일}}의 현지 시간 {{P2}}까지, {{CancellationFeeDescription}}.',
    DESC_UPTO_X_HOURS_BEFORE_WITH_CHARGE:
      '예약 확정일로부터 참가 일시 {{P1}}시간 전까지, {{CancellationFeeDescription}}.',
    DESC_AFTER_X_DAYS_FROM_TIME_WITH_CHARGE:
      '참가일 {{P1}}일 전 현지 시간 {{P2}} 이후, {{CancellationFeeDescription}}',
    DESC_AFTER_X_HOURS_FROM_TIME_WITH_CHARGE:
      '참가 일시 {{P1}}시간 전 이후, {{CancellationFeeDescription}}',
    DESC_BETWEEN_X_TO_Y_DAYS_WITH_CHARGE:
      '참가일 {{P1}}일 전 현지 시간 {{P2}}부터 {{P3}}일 전 현지 시간 {{P4}}까지, {{CancellationFeeDescription}}',
    DESC_BETWEEN_X_DAYS_TO_Y_HOURS_WITH_CHARGE:
      '참가일 {{P1}}일 전 현지 시간 {{P2}}부터 당일 현지 시간 {{P3}}까지, {{CancellationFeeDescription}}',
    DESC_BETWEEN_X_TO_Y_HOURS_WITH_CHARGE:
      '참가 일시 {{P1}}시간 전부터 {{P2}}시간 전까지, {{CancellationFeeDescription}}',
    DESC_BETWEEN_X_HOURS_TO_0_WITH_CHARGE:
      '참가 일시 {{P1}}시간 전부터 참가 당일 현지 시간 {{P2}}까지, {{CancellationFeeDescription}}',
    DESC_BEFORE_X_DAYS_AFTER_BOOKING_WITH_CHARGE:
      '예약 확정일을 0일로 하여 계산한 {{P2}}일째 현지 시간 {{P1}}까지, {{CancellationFeeDescription}}',
    DESC_BEFORE_X_HOURS_AFTER_BOOKING_WITH_CHARGE:
      '예약 확정 후 {{P1}}시간 전까지, {{CancellationFeeDescription}}',
    DESC_AFTER_X_DAYS_FROM_BOOKING_WITH_CHARGE:
      '예약 확정일을 0일로 하여 계산한 {{P2}}일째 현지 시간 {{P1}} 이후, {{CancellationFeeDescription}}',
    DESC_AFTER_X_HOURS_FROM_BOOKING_WITH_CHARGE:
      '예약 확정 후 {{P1}}시간 이후, {{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_DAYS_AND_X_DAYS_WITH_CHARGE:
      '예약 확정일을 0일로 하여 계산한 {{P2}}일째 현지 시간 {{P1}}부터 참가일 {{P4}}일 전 현지 시간 {{P3}}까지, {{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_DAYS_AND_X_HOURS_WITH_CHARGE:
      '예약 확정일을 0일로 하여 {{P2}}일째 현지 시간 {{P1}}부터 참가 일시 {{P3}}시간 전까지, {{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_HOURS_AND_X_HOURS_WITH_CHARGE:
      '예약 확정 후 {{P1}}시간부터 참가 일시 {{P2}}시간 전까지, {{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_DAYS_START_AND_END_WITH_CHARGE:
      '예약 확정일을 0일로 하여 계산한 {{P2}}일째 현지 시간 {{P1}}부터 {{P4}}일째 현지 시간 {{P3}}까지, {{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_DAYS_START_AND_HOURS_WITH_CHARGE:
      '예약 확정일을 0일로 하여 계산했을 때, {{P2}}일째 현지 시간 {{P1}}부터 예약 확정 후 {{P3}}시간 전까지, {{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_HOURS_START_AND_END_WITH_CHARGE:
      '예약 확정 후 {{P1}}시간부터 예약 확정 후 {{P2}}시간 전까지, {{CancellationFeeDescription}}'
  },
  cancellationFeeDescription: {
    FEE_PERCENTAGE: '주문 총액의 {{value}}%를 취소 수수료로 부과합니다',
    FEE_FIXED: '{{value}}를 취소 수수료로 부과합니다',
    FEE_PER_PARTICIPANT: '참가자 1인당 {{value}}를 취소 수수료로 부과합니다',
    FEE_NOT_TO_BE_CANCELLED: '취소 불가'
  }
};
